export default "__VITE_ASSET__BzqhuS09__";